import { connect } from 'react-redux'
import values from 'lodash/values'
import orderBy from 'lodash/orderBy'

import { fetchUnsatisfactoryServicingVersions, updateServicingVersion } from '../../actions/servicing-versions'

import WorkTrackerServicingVersions from '../../components/work-trackers/work-tracker-servicing-versions'

function mapStateToProps (state, ownProps) {
  const { locationId } = ownProps.params
  const { contractId, technicianId } = ownProps.location.query

  const techSVs = state.technicianServicingVersions[technicianId]
  const servicingVersions = techSVs && techSVs['servicingVersions'] ? values(techSVs['servicingVersions'][contractId]) : []

  const location = state.locations[locationId]
  const contract = state.contracts[contractId]

  return {
    locationModel: location,
    contract,
    servicingVersions: orderBy(servicingVersions, 'createdAt', 'desc')
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId
  const { contractId, technicianId } = ownProps.location.query

  dispatch(fetchUnsatisfactoryServicingVersions(technicianId, contractId))

  return {
    removeServicing (servicingVersionId) {
      dispatch(updateServicingVersion(servicingVersionId, { unsatisfactory_check: true })).then(() => dispatch(fetchUnsatisfactoryServicingVersions(technicianId, contractId)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkTrackerServicingVersions)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-servicing-versions-container.js